import styled, { css } from 'styled-components';
import { colours, fonts } from 'themes/default';
const { fontSizeRegular } = fonts;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => (props.checked ? colours.Core.CoreBlue : colours.Greyscale.SilverGrey)};
  border-radius: 2px;
  background: ${(props) => (props.checked ? colours.Core.CoreBlue : colours.Greyscale.White)};
  width: 25px;
  height: 25px;
  cursor: pointer;

  ${/* sc-selector */ HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 2px ${colours.Shades.TintBlue20};
  }

  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
          pointer-event: none;
          opacity: 0.6;
          background: ${(props) => (props.checked ? colours.Core.CoreBlue : colours.Greyscale.MistGrey)};
        `
      : null}

  svg {
    width: 12px;
    stroke: white;
    stroke-width: 6px;
  }
`;

const StyledCheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

const StyledLabel = styled.span`
  color: ${colours.Shades.BlueShade40};
  margin-left: 16px;
  line-height: 25px;
  font-size: ${fontSizeRegular};
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
`;

export { HiddenCheckbox, StyledCheckbox, StyledCheckboxContainer, StyledLabel };
